import { render, staticRenderFns } from "./AppTripHeader.vue?vue&type=template&id=7583586c&scoped=true&"
import script from "./AppTripHeader.vue?vue&type=script&lang=ts&"
export * from "./AppTripHeader.vue?vue&type=script&lang=ts&"
import style0 from "./AppTripHeader.vue?vue&type=style&index=0&id=7583586c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7583586c",
  null
  
)

export default component.exports